//import logo from "./logo.svg";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useEffect, useState } from "react";
import NoInternet from "./NoInternet";
import Layout from "./Component/Home/Layout";
import Routing from "./Routes/routers";
import Unauthorized from "./Routes/Unauthorized";
import ChatWidget from "./Component/Support/SupportChat";
import { useSelector } from "react-redux";
import QuickNotes from "./Component/Notes/QuickNotes";
import NotificationBell from "./Component/Notifications/NotificationBell";
import "react-datepicker/dist/react-datepicker.css";

function App() {
  const [online, setOnline] = useState(window.navigator.onLine);
  const [userRights, setUserRights] = useState("");
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;

  useEffect(() => {
    const handleOnlineStatus = () => {
      setOnline(window.navigator.onLine);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);

  return (
    <BrowserRouter>
      {!online && <NoInternet />}

      {
        //online && (
        //  <Routing userRights={userRights} setUserRights={setUserRights} />
        // )
      }
      {online && (
        <Layout>
           <NotificationBell userData={userData} />
          <Routing userRights={userRights} setUserRights={setUserRights} />
          <QuickNotes userData={userData} />
        </Layout>
      )}
      <ChatWidget userData={userData} />
    </BrowserRouter>
  );
}

export default App;
